import { render } from "./ArrowButton.vue?vue&type=template&id=13454fa4&scoped=true&ts=true"
import script from "./ArrowButton.vue?vue&type=script&lang=ts"
export * from "./ArrowButton.vue?vue&type=script&lang=ts"

import "./ArrowButton.vue?vue&type=style&index=0&id=13454fa4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13454fa4"]])

export default __exports__